import { IRecordedInterviewScoresExtended } from '../types';

const convertArrayOfObjectsToCSV = (array: IRecordedInterviewScoresExtended[]) => {
  const columnDelimiter = ',';
  const lineDelimiter = '\n';

  const keys: Array<keyof IRecordedInterviewScoresExtended> = [
    'question',
    'answer',
    'whisperAnswer',
    'originalTranscriptScore',
    'originalTranscriptExplanation',
    'combinedTranscriptText',
    'languageProficiencyScore',
    'languageProficiencyExplanation',
    'answerScore',
    'answerExplanation',
    'facialRecognitionScore',
  ];

  let result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;
      result += `"${item?.[key] ?? ''}"`;
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
};

export default function downloadStudentInterviewScoresCSV(studentNo: string, data: IRecordedInterviewScoresExtended[]) {
  const filename = `${studentNo ?? 'data'}.csv`;
  let csv = convertArrayOfObjectsToCSV(data);

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }
  const dataURI = encodeURI(csv);

  const link = document.createElement('a');
  link.setAttribute('href', dataURI);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
